module.exports = __webpack_public_path__ + "assets/4ed150e95ba88bbc112368fef99de38e.mp4";